import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdmissionComponent } from './view/admission/admission.component';
import { HomeComponent } from './view/home/home.component';


const routes: Routes = [
  {path:'',component:HomeComponent},
  {path:'about',loadChildren:'./modules/about/about.module#AboutModule'},
  {path:'infrastructure',loadChildren:'./modules/infrastructure/infrastructure.module#InfrastructureModule'},
  {path:'beyond',loadChildren:'./modules/beyond/beyond.module#BeyondModule'},
  {path:'award',loadChildren:'./modules/award/award.module#AwardModule'},
  {path:'tiny-tots',loadChildren:'./modules/tiny/tiny.module#TinyModule'},
  {path:'blogs', loadChildren:'./modules/blogs/blogs.module#BlogsModule'},
  {path:'admission',component:AdmissionComponent},
  {path:'gallery',loadChildren:'./modules/gallery/gallery.module#GalleryModule'},
  {path:'contact-us',loadChildren:'./modules/contact/contact.module#ContactModule'},
  {path:'Mandatory-Public-Disclosure',loadChildren:'./modules/mandatory/mandatory.module#MandatoryModule'},
  {path:'staff',loadChildren:'./modules/staff/staff.module#StaffModule'},
  {path:'**',redirectTo:'/',pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
